import React from 'react'
import {motion} from 'framer-motion'
import FaqData from './FaqData'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Faquestions.scss'
import Question from './Questions'

const Faquestions = () => {
  return (
    <div className='app__faq-wrapper-upper'>
      <motion.h2 
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.6}}
        className='head-text'
      >
        Frequently <span>Asked</span> Questions 
      </motion.h2>
      
      <div className='app__faq-wrapper'>
        <div className='app__faq-intro'>
          <motion.p
            whileInView={{opacity: [0, 1]}}
            transition={{duration: 0.6}}
            className='p-text'
          >
            Have questions about our services? Find answers to common inquiries below. 
            For specific questions, feel free to <span className='bold-text'>contact us directly</span>.
          </motion.p>
        </div>

        <div className='app__faq'>
          <motion.div
            whileInView={{opacity: [0, 1], y: [50, 0]}}
            transition={{duration: 0.6}}
            className='app__faq-item'
          >
            <section className="app__faq-item_info">
              {FaqData.map((question, index) => (
                <motion.div
                  key={question.id}
                  initial={{opacity: 0, y: 20}}
                  whileInView={{opacity: 1, y: 0}}
                  transition={{duration: 0.3, delay: index * 0.05}}
                >
                  <Question {...question} />
                </motion.div>
              ))}
            </section>
          </motion.div>
        </div>
        
        <motion.div
          whileInView={{opacity: [0, 1]}}
          transition={{duration: 0.7, delay: 0.3}}
          className='app__faq-contact'
        >
          <p className='p-text'>
            Still have questions? <a href="#contact" className='app__faq-contact-link'>Get in touch with our team</a>
          </p>
        </motion.div>
      </div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(Faquestions, 'app__faq-section'),
  'faquestions',
  'app__whitebg'
)